/**
 * FollowUpEngineCockpit — Cockpit-language frame for /follow-up-engine.
 */
import {
  CockpitPage, CockpitMasthead, HeroMetric, HeroDivider, CockpitKpiStrip,
} from "@/components/cockpit/CockpitShell";
import { useFollowUpEngine } from "@/data/FollowUpEngineContext";
import FollowUpEngine from "./FollowUpEngine";

export default function FollowUpEngineCockpit() {
  const { config } = useFollowUpEngine();
  const activeRules = config.rules.filter((r) => r.active).length;
  const totalRules = config.rules.length;
  const templates = config.templates.length;
  const sequences = config.sequences.length;

  return (
    <CockpitPage>
      <CockpitMasthead
        eyebrow="Automations & Intelligence · Engagement"
        title="Follow-Up Engine"
        right={
          <>
            <HeroMetric label="Active Rules" value={activeRules} hero />
            <HeroDivider />
            <HeroMetric label="Templates" value={templates} />
            <HeroDivider />
            <HeroMetric label="Sequence Steps" value={sequences} />
          </>
        }
      />
      <CockpitKpiStrip
        items={[
          { label: "Total Rules", value: totalRules },
          { label: "Active", value: activeRules, tone: "good" },
          { label: "Templates", value: templates },
          { label: "Sequences", value: sequences },
        ]}
      />
      <div className="cockpit-surface">
        <FollowUpEngine />
      </div>
    </CockpitPage>
  );
}
